// extracted by mini-css-extract-plugin
export default {"estoque":"Estoque_estoque__rr4vv","estoque__titulo":"Estoque_estoque__titulo__FbNC6","estoque__container":"Estoque_estoque__container__Kqt0u"};